'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import { useCallback } from 'react'

import { useCalendly } from '@/components/integrations/calendly/calendly-provider'

type CalendlyNavLinkProps = {
  label: string
  className?: string
  user?: string | null
  closeDialogId?: string
}

export function CalendlyNavLink({ label, className, user, closeDialogId }: CalendlyNavLinkProps) {
  const { open, warmup } = useCalendly()

  const handleClick = useCallback(() => {
    open({ user, location: 'site-nav' })
    if (!closeDialogId) {
      return
    }
    const dialog = document.getElementById(closeDialogId)
    if (dialog instanceof HTMLDialogElement) {
      dialog.close()
    }
  }, [open, user, closeDialogId])

  return (
    <button
      type="button"
      onClick={handleClick}
      onPointerEnter={warmup}
      onFocus={warmup}
      className={clsx(
        'group inline-flex cursor-pointer items-center justify-between gap-2 text-3xl/10 font-medium text-mist-950 lg:text-sm/7 dark:text-white',
        className,
      )}
    >
      {label}
      <span className="inline-flex p-1.5 opacity-0 group-hover:opacity-100 lg:hidden" aria-hidden="true">
        <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </span>
    </button>
  )
}
